import React from 'react'
import { ProjectFormEnum } from 'shared'
import { BuildingPermitAccompanyingReportFields } from './reportTypes/buildingPermit/BuildingPermitAccompanyingReportFields'
import { DemolitionAccompanyingReportFields } from './reportTypes/demolition/DemolitionAccompanyingReportFields'

interface Props {
  projectForm: ProjectFormEnum
}

export const AccompanyingReportFields: React.FC<Props> = (props) => {
  if (props.projectForm === ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1) {
    return <BuildingPermitAccompanyingReportFields />
  }

  if (props.projectForm === ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1) {
    return <DemolitionAccompanyingReportFields />
  }

  return null
}
